module.exports = __webpack_public_path__ + "img/users.a84b57bc.svg";